import styled, { css } from 'styled-components'

import { fromMd } from '@syconium/little-miss-figgy'

export const Radio = styled.input.attrs({
  ...{
    type: 'radio',
  },
})`
  display: none;

  &:checked + span {
    font-weight: bold;
  }
`

export const TabNav = styled.div`
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  display: flex;
  font-weight: 500;
  font-size: 14px;
  justify-content: space-evenly;
  letter-spacing: 0.15em;
`

export const TabLabel = styled.label`
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  flex-grow: 1;
  font-size: 14px;
  height: 30px;
  min-width: 115px;
  white-space: nowrap;

  &:hover {
    cursor: pointer;
  }

  > input[type='radio']:checked + span {
    color: ${o => o.theme.color.deprecated.obsidian};
    border-bottom: 3px solid black;
    padding-bottom: 1px;
  }
`
export const ChartNav = styled.div`
  border-bottom: 1px solid ${o => o.theme.color.deprecated.stone};
  display: flex;
  letter-spacing: 0.05em;
  margin-top: 4px;
  overflow: auto;

  ${fromMd} {
    border-bottom: none;
    flex-direction: column;
    flex-wrap: nowrap;
  }
`

export const ChartNavWrap = styled.div<{
  showLeftShadow: boolean
  showRightShadow: boolean
}>`
  position: relative;
  ${o =>
    o.showRightShadow &&
    css`
      &::after {
        background: linear-gradient(
          to left,
          rgba(255, 255, 255, 1) 0%,
          rgba(255, 255, 255, 0) 100%
        );
        content: '';
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        width: 15%;
      }
    `}

  position: relative;
  ${o =>
    o.showLeftShadow &&
    css`
      &::before {
        background: linear-gradient(
          to right,
          rgba(255, 255, 255, 1) 0%,
          rgba(255, 255, 255, 0) 100%
        );
        content: '';
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        width: 15%;
      }
    `}
`

export const Label = styled.label`
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  flex-grow: 1;
  flex-shrink: 0;
  font-weight: 500;
  font-size: 14px;
  padding: 20px 15px;

  &:hover {
    cursor: pointer;
  }

  > input[type='radio']:checked + span {
    color: ${o => o.theme.color.deprecated.obsidian};
  }
`

export const Span = styled.span`
  border-bottom: 1px solid ${o => o.theme.color.deprecated.stone};
  display: block;
  height: 100%;
  overflow: hidden;
  padding-bottom: 3px;
  text-align: center;
  width: 100%;
`
